import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/authService';

interface ProtectedRouteProps {
  children: React.ReactElement;
  roles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, roles }) => {
  const { isAuthenticated, hasRole, logoutWithMessage } = useAuth();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Check token expiration directly on mount and when route changes
    const currentUser = authService.getCurrentUser();
    if (currentUser && currentUser.token) {
      if (authService.isTokenExpired(currentUser.token)) {
        // Token is expired, logout immediately
        logoutWithMessage('Your session has expired. Please log in again.');
        setIsChecking(false);
        return;
      }
    }
    setIsChecking(false);
  }, [logoutWithMessage]);

  // Show nothing while checking to prevent blank screen flash
  if (isChecking) {
    return null;
  }

  // Check authentication status - verify token is still valid
  const currentUser = authService.getCurrentUser();
  const isUserLoggedIn = currentUser ? authService.isUserLoggedIn() : false;

  if (!isAuthenticated || !isUserLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !hasRole(roles)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
